import React, { useEffect, useState } from 'react';
import { useAuth } from '../../lib/auth';
import { fiscal } from '../../lib/exportsFiscaux';
const nouvelle = () => ({ du: '', au: '', taux_salarial: '', taux_patronal: '', pointages_bruts_confirmes: false });

export default function ParametresCnss() {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);
  const [erreur, setErreur] = useState('');
  const [occupe, setOccupe] = useState(false);
  const [message, setMessage] = useState('');
  const [revision, setRevision] = useState(0);
  const admin = user?.role === 'Administrateur';
  useEffect(() => {
    if (!admin) return undefined;
    const c = new AbortController();
    setConfig(null); setErreur('');
    fiscal('/configuration-cnss', { signal: c.signal }).then(setConfig).catch(e => { if (e.name !== 'AbortError') setErreur(e.message); });
    return () => c.abort();
  }, [admin, revision]);
  if (!admin) return null;
  function changer(index, cle, valeur) {
    setMessage(''); setConfig(old => ({ ...old, periodes: old.periodes.map((p, i) => i === index ? { ...p, [cle]: valeur } : p) }));
  }
  async function sauver(e) {
    e.preventDefault(); setOccupe(true); setErreur(''); setMessage('');
    try {
      const data = await fiscal('/configuration-cnss', { method: 'PUT', body: config });
      setConfig(data); setMessage(`Configuration enregistrée, version ${data.version}.`);
    } catch (err) { setErreur(err.message); }
    finally { setOccupe(false); }
  }
  return <section className="border border-slate-200 bg-white p-4 space-y-3" aria-label="Paramètres CNSS">
    <h2 className="font-bold">CNSS — préparation des cotisations</h2>
    <p className="text-sm text-slate-600">Saisissez les taux validés pour votre régime et leur période d’application. Aucun taux par défaut. Une correction historique reste tracée et peut modifier un export régénéré.</p>
    <p className="text-sm text-slate-600">La base utilisée est le montant déjà enregistré dans les pointages, sans recalcul des salaires. Ne confirmez l’assiette que si ces montants sont bien bruts et cotisables. Cet état ne calcule pas une paie complète.</p>
    {erreur && <p role="alert" className="text-red-700">{erreur}</p>}
    {message && <p role="status" className="text-emerald-700">{message}</p>}
    {!config ? <button type="button" onClick={() => setRevision(r => r + 1)}>{erreur ? 'Réessayer le chargement' : 'Chargement…'}</button> : <form onSubmit={sauver} className="space-y-3">
      <fieldset disabled={occupe} className="space-y-3">
        {config.periodes.map((p, i) => <div key={i} className="border border-slate-200 p-3 space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
            {[['du', 'Premier mois'], ['au', 'Dernier mois'], ['taux_salarial', 'Taux salarial (%)'], ['taux_patronal', 'Taux patronal (%)']].map(([cle, label]) => <label key={cle} className="text-sm">{label}
              <input aria-label={`${label} ${i + 1}`} required type={cle.startsWith('taux') ? 'number' : 'month'}
                min={cle.startsWith('taux') ? '0' : undefined} max={cle.startsWith('taux') ? '100' : undefined}
                step={cle.startsWith('taux') ? '0.0001' : undefined} value={p[cle]}
                onChange={e => changer(i, cle, e.target.value)} className="block w-full border border-slate-300 p-2" />
            </label>)}
          </div>
          <label className="flex gap-2 text-sm"><input type="checkbox" checked={p.pointages_bruts_confirmes}
            onChange={e => changer(i, 'pointages_bruts_confirmes', e.target.checked)} />Je confirme que les montants pointés sur cette période constituent l’assiette brute cotisable à utiliser.</label>
          <button type="button" className="text-sm text-red-700" onClick={() => setConfig(c => ({ ...c, periodes: c.periodes.filter((_, n) => n !== i) }))}>Retirer cette période</button>
        </div>)}
        <div className="flex flex-wrap gap-3">
          <button type="button" className="border px-3 py-2" onClick={() => setConfig(c => ({ ...c, periodes: [...c.periodes, nouvelle()] }))}>Ajouter une période</button>
          <button type="submit" className="bg-slate-900 text-white px-3 py-2">{occupe ? 'Enregistrement…' : 'Enregistrer les paramètres CNSS'}</button>
          <button type="button" className="border px-3 py-2" onClick={() => { setMessage(''); setRevision(r => r + 1); }}>Recharger la configuration serveur</button>
        </div>
      </fieldset>
    </form>}
  </section>;
}
